import React, { useContext, useEffect, useState } from 'react';

import { UserDetailsContext } from 'context/userDetailsContext';

import EventTitle from 'modules/calendar/Components/CreateEventModal/Components/EventTitle';
import EventVideoConferenceUrl from 'modules/calendar/Components/CreateEventModal/Components/EventVideoConferenceUrl';
import EventDescription from 'modules/calendar/Components/CreateEventModal/Components/EventDescription';
import EventReminders from 'modules/calendar/Components/CreateEventModal/Components/EventReminders';
import EventRecurring from 'modules/calendar/Components/CreateEventModal/Components/EventRecurring';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import EventPracticeArea from 'modules/calendar/Components/CreateEventModal/Components/EventPracticeArea';
import CourtEventType from './components/CourtEventType';
import CourtEventDate from './components/CourtEventDate';
import CourtEventTime from './components/CourtEventTime';
import CourtEventLocation from './components/CourtEventLocations';
import CourtEventAttendees from './components/CourtEventAttendees';
import CourtEventAttachments from './components/CourtEventAttachments';
// import { roundToNextHalfHour } from 'utils/utility_functions/timezone';
// import moment from 'moment';
import moment from 'moment-timezone';

function CreateCourtEventForm({
  selectedItem,
  control,
  resetField,
  setValue,
  getValues,
  watch,
  errors,
  trigger,
  handleUploadAttachements,
  uploadedAttachments,
  courtEventExtractedData,
  locationsList,
  hadleAddNewLocation,
}) {
  const { isGlobalFileManager } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);
  const [showReminder, setShowReminder] = useState(false);

  const startTimeWatcher = watch('meeting_start_time');

  useEffect(() => {
    if (!courtEventExtractedData) return;

    const details = courtEventExtractedData.details;
    if (!details) return;

    const { title, court_date, court_time } = details;

    // // Title
    // if (title !== -1) {
    // Title — only set if extraction returned a real value (not -1, null, or undefined)
    if (title && title !== -1) {
      setValue('title', title);
    }

    // Date
    const userTimezone = userContext?.userDetails?.timezone;
    const timezone = userTimezone || moment.tz.guess();

    // Safely compute current date/time in user's timezone using toLocaleString.
    // This never throws — if timezone is invalid it falls back to browser local time.
    const tzNow = userTimezone ? new Date(new Date().toLocaleString('en-US', { timeZone: userTimezone })) : new Date();

    // Date — guard against both the -1 sentinel AND null/undefined from failed extraction
    if (court_date && court_date !== -1) {
      setTimeout(() => {
        // setValue('when', moment(court_date, 'MM-DD-YYYY').tz(userContext?.userDetails?.timezone).toDate());
        setValue('when', moment(court_date, 'MM-DD-YYYY').tz(timezone).toDate());
      }, 500);
    } else {
      // setValue('when', null);
      // Fall back to current date in user's timezone
      const fallbackDate = new Date(tzNow.getFullYear(), tzNow.getMonth(), tzNow.getDate(), 0, 0, 0, 0);
      setTimeout(() => {
        setValue('when', fallbackDate);
      }, 500);
    }

    // Time
    // if (court_time !== -1) {
    // Time — guard against both the -1 sentinel AND null/undefined from failed extraction
    if (court_time && court_time !== -1) {
      const formattedTime = formatTime(court_time);

      setValue('meeting_start_time', formattedTime);
      // addTimeHandler(roundToNextHalfHour(formattedTime), 30, 'meeting_end_time');
      addTimeHandler(roundToMinutes(formattedTime, 30), 30, 'meeting_end_time');
    } else {
      // setValue('meeting_start_time', fallbackTime);
      // setValue('meeting_end_time', null);
      // Fall back to current time in user's timezone, rounded to next 15 minutes
      const fallbackTime = new Date(tzNow);
      fallbackTime.setSeconds(0);
      fallbackTime.setMilliseconds(0);
      const roundedStartTime = roundToMinutes(fallbackTime, 15);
      setValue('meeting_start_time', roundedStartTime);
      addTimeHandler(roundedStartTime, 30, 'meeting_end_time');
    }
  }, [courtEventExtractedData]);

  function roundToMinutes(date, minutes) {
    const rounded = new Date(date.getTime());
    const remainder = rounded.getMinutes() % minutes;
    if (remainder !== 0) {
      rounded.setMinutes(rounded.getMinutes() + minutes - remainder);
    }
    rounded.setSeconds(0, 0);
    return rounded;
  }

  function addTimeHandler(time, extraTime, field) {
    if (time) {
      let new_time = new Date(time);
      let addedTime = new_time.setMinutes(new_time.getMinutes() + extraTime);
      let endTime = new Date(addedTime);
      setValue(field, endTime);
      trigger('meeting_end_time');
    }
  }
  let timezoneBasedTime = new Date().toLocaleString('en-US', {
    timeZone: userContext?.userDetails?.timezone,
  });

  function formatTime(isoString) {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const amOrPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
  }

  const handleShowReminder = (show) => {
    if (!show) {
      setShowReminder(false);
    } else {
      setShowReminder(true);
    }
  };

  return (
    <form>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="modal-heading F-size16 text-bold">{'Court Event Details'}</div>
      </div>
      <div className="court-form-contents pe-2">
        <EventTitle control={control} errors={errors} watch={watch} />
        <CourtEventType control={control} setValue={setValue} resetField={resetField} watch={watch} />
        <CourtEventDate
          control={control}
          trigger={trigger}
          errors={errors}
          setValue={setValue}
          timezoneBasedTime={timezoneBasedTime}
          watch={watch}
        />
        <CourtEventTime
          control={control}
          trigger={trigger}
          errors={errors}
          setValue={setValue}
          startTimeWatcher={startTimeWatcher}
          watch={watch}
        />
        <EventRecurring
          control={control}
          resetField={resetField}
          setValue={setValue}
          trigger={trigger}
          watch={watch}
          isGlobal={isGlobalFileManager}
          errors={errors}
          timezoneBasedTime={timezoneBasedTime}
        />
        <EventVideoConferenceUrl control={control} watch={watch} />
        <CourtEventLocation
          control={control}
          setValue={setValue}
          locationsList={locationsList}
          hadleAddNewLocation={hadleAddNewLocation}
          courtEventExtractedData={courtEventExtractedData}
          watch={watch}
        />
        {(!selectedItem?.case_id || selectedItem?.case_id.trim() === 'undefined') && (
          <EventPracticeArea key={selectedItem?.case_id} control={control} setValue={setValue} watch={watch} />
        )}
        <CourtEventAttendees
          control={control}
          getValues={getValues}
          setValue={setValue}
          trigger={trigger}
          watch={watch}
          selectedItem={selectedItem}
          handleShowReminder={handleShowReminder}
          showReminder={showReminder}
          errors={errors}
        />
        <EventDescription control={control} watch={watch} />
        <CourtEventAttachments
          control={control}
          setValue={setValue}
          getValues={getValues}
          handleUploadAttachements={handleUploadAttachements}
          uploadedAttachments={uploadedAttachments}
          watch={watch}
        />
        <EventReminders
          control={control}
          setValue={setValue}
          watch={watch}
          isGlobal={isGlobalFileManager}
          errors={errors}
          isRequired={showReminder}
          optionText="before event start time"
        />
      </div>
    </form>
  );
}

export default CreateCourtEventForm;
